export const NIPPONRIKA_THEME = {
  name: 'default',
  base: null,
  variables: {

  },
};
